import { Button, Col, DatePicker, Modal, PageHeader, Row, Select, Spin, Table, Tag, notification } from 'antd';
import moment from 'moment';
import React, { Component } from 'react';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import { Card, CardBody, FormGroup } from 'reactstrap';
import { CheckTokenExp, pathimages, token, urlapi } from '../../config';
import TemplateId from '../Dropdown/TemplateId';
import TemplateName from '../Dropdown/TemplateName';
import copy from "copy-to-clipboard";

class Template extends Component {
    constructor(props) {
        super(props);

        this.RequestTemplateInfo = this.RequestTemplateInfo.bind(this);
        this.RequestDropdownTemplateInfo = this.RequestDropdownTemplateInfo.bind(this);
        this.onChangePage = this.onChangePage.bind(this);
        this.onChangeinput = this.onChangeinput.bind(this);
        this.onChangeSelect = this.onChangeSelect.bind(this);
        this.onChangedate = this.onChangedate.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.handleCancelModel = this.handleCancelModel.bind(this);
        this.showModal = this.showModal.bind(this);

        this.state = {
            file: "",
            images: "",
            tempName: undefined,
            tempId: undefined,
            tempType: "",
            status: "",
            startDate: "",
            endDate: "",
            templist: [],
            dropdownlist: [],
            tempSearch: [],
            tempContent: "",
            minpage: 1,
            pagesize: 10,
            current: 1,
            totalpage: 0,
            tableloading: false,
            visible: false,
            copyClipboard: false
        }
    }

    componentDidMount() {
        this.RequestTemplateInfo(1, this.state.pagesize);
        this.RequestDropdownTemplateInfo();
    }

    //==== Request TemplateInfo ====
    RequestTemplateInfo(startdata, enddata) {
        if (!CheckTokenExp()) {
            this.setState({ tableloading: true })
            let req = JSON.stringify({
                TempName: this.state.tempName === undefined ? "" : this.state.tempName,
                TempId: this.state.tempId === undefined ? "" : this.state.tempId,
                // TempType: this.state.tempType === "" ? 0 : this.state.tempType === "TEXT" ? 1 : 2,
                TempStatus: this.state.tempStatus,
                startDate: this.state.startDate,
                endDate: this.state.endDate,
                startData: startdata,
                endData: enddata
            });

            fetch(urlapi + "api/requestTemplate", {
                method: 'post',
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    "Authorization": "Bearer " + token
                },
                body: req
            }).then(
                function (data) {
                    if (data.ok) {
                        data.json().then(
                            function (json) {
                                this.setState({ totalpage: json.totalpage, templist: json.data, tempSearch: json.data2 });
                                this.setState({ currentpage: startdata == 1 ? 1 : this.state.currentpage });
                                this.setState({ tableloading: false });
                            }.bind(this)
                        );
                    } else {
                        this.setState({ tableloading: false });
                    }
                }.bind(this)
            ).catch(function () {
                this.setState({ tableloading: false });
                Modal.error({
                    content: 'Error on the internal server',
                });
            }.bind(this));
        } else {
            this.props.history.push("/logout");
        }
    }

    //==== RequestDropdown TemplateInfo ====
    RequestDropdownTemplateInfo() {
        if (!CheckTokenExp()) {
            fetch(urlapi + "api/requestDropdownTemplate", {
                method: 'get',
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    "Authorization": "Bearer " + token
                },
            }).then(
                function (data) {
                    if (data.ok) {
                        data.json().then(
                            function (json) {
                                this.setState({ dropdownlist: json.data });
                            }.bind(this)
                        );
                    }
                }.bind(this)
            ).catch(function () {
                this.setState({ tableloading: false });
                Modal.error({
                    content: 'Error on the internal server',
                });
            }.bind(this))
        } else {
            this.props.history.push("/logout");
        }
    }

    onSearch() {
        this.RequestTemplateInfo(1, this.state.pagesize)
    }

    onChangePage(currentPage, pageSize) {
        var enddata = currentPage * pageSize;
        var startdata = ((currentPage * pageSize) + 1) - pageSize;
        this.setState({ currentpage: currentPage, pagesize: pageSize });

        this.RequestTemplateInfo(startdata, enddata)
    }

    onChangeinput(e) {
        this.setState({ [e.target.name]: e.target.value });
    }

    onChangeSelect(value, e) {
        this.setState({ [e.props.name]: value });
    }

    onChangedate(date, dateString) {
        this.setState({ startDate: dateString[0], endDate: dateString[1] });
    }

    showModal(item) {
        this.setState({
            visible: true,
            images: item.ltmP_IMAGE_ID,
            tempContent: item.ltmP_PRE_PARAM,
        });
    };

    handleCancelModel() {
        this.setState({
            visible: false,
        });
    };

    copyToClipboard(tempContent) {
        copy(tempContent)
        notification.success({
            message: (
                <div style={{ fontSize: '22px' }}>
                    Clipboard copied successfully
                </div>
            ),
            placement: 'bottomRight'
        });
    }

    render() {
        const { Option } = Select;
        const { RangePicker } = DatePicker;
        const dateFormat = 'DD/MM/YYYY';
        const columns = [
            // {
            //     title: 'Type',
            //     dataIndex: 'ltmP_TYPE',
            //     key: 'ltmP_TYPE',
            //     width: '10%',
            // },
            {
                title: 'Template Name',
                dataIndex: 'ltmP_NAME',
                key: 'ltmP_NAME',
                width: '20%',
            },
            {
                title: 'Template ID',
                dataIndex: 'ltmP_ID',
                key: 'ltmP_ID',
                width: '25%',
            },
            {
                title: 'Create date',
                dataIndex: 'ltmP_CREATED_DATE',
                key: 'ltmP_CREATED_DATE',
                width: '15%',
            },
            {
                title: 'Status',
                dataIndex: 'ltmP_STATUS',
                key: 'ltmP_STATUS',
                width: '10%',
                render: tags => (
                    <Tag style={{ textAlign: 'center' }}
                        className={
                            tags == "Active" ? "tag-complete" :
                                tags == "In Process" ? "tag-inProgres" : ""

                        }>
                        {tags}
                    </Tag>
                ),
            },
            {
                dataIndex: 'key',
                key: 'key',
                width: '15%',
                render: (key, item) => (
                    <Row gutter={8}>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                            <span style={{ textAlign: 'center', cursor: 'pointer' }}>
                                <i
                                    className="fa fa-eye ants-gray"
                                    onClick={() => this.showModal(item)}
                                ></i>
                            </span>
                        </Col>
                    </Row>
                ),
            },
        ];
        const data = this.state.templist;
        return (
            <div>
                <PageHeader title="Template">
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Row gutter={[16, 16]}>
                            {/* <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                                <StatusType
                                    onchange={(e) =>
                                        this.setState({ tempType: e })
                                    }
                                />
                            </Col> */}

                            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                                <TemplateName
                                    dropdownlist={this.state.dropdownlist}
                                    onchange={(e) =>
                                        this.setState({ tempName: e })
                                    }
                                />
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                                <TemplateId
                                    dropdownlist={this.state.dropdownlist}
                                    onchange={(e) =>
                                        this.setState({ tempId: e })
                                    }
                                />
                            </Col>
                            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
                                <Select
                                    defaultValue={0}
                                    name="tempStatus"
                                    onChange={this.onChangeSelect}
                                    suffixIcon={<span className="fa fa-angle-down" />}
                                >
                                    <Option name="tempStatus" value={0}>Status</Option>
                                    <Option name="tempStatus" value={1}>Active</Option>
                                    <Option name="tempStatus" value={2}>In Process</Option>
                                </Select>
                            </Col>
                            {/* </Row>
                        <Row gutter={[16, 16]}> */}
                            <Col xs={24} sm={12} md={16} lg={16} xl={16}>
                                <RangePicker
                                    style={{ width: "100%" }}
                                    format={dateFormat}
                                    suffixIcon={<span className="fa fa-calendar-o" />}
                                    onChange={this.onChangedate}
                                    ranges={{
                                        Today: [moment().startOf('day'), moment().endOf('day')],
                                        'Last 7 days': [moment().subtract(6, 'd'), moment()],
                                        'Last week': [moment().subtract(1, 'weeks').startOf('week'), moment().subtract(1, 'weeks').endOf('week')],
                                        'Last 15 days': [moment().subtract(14, 'd'), moment()],
                                        'Last 30 days': [moment().subtract(29, 'd'), moment()],
                                        'This month': [moment().startOf('month'), moment().endOf('month')]
                                    }}
                                />
                            </Col>

                            <Col xs={24} sm={24} md={8} lg={8} xl={8} >
                                <Button icon="search" style={{ width: '100%' }} onClick={this.onSearch}>
                                    Search
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                </PageHeader>

                <div className="content">
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Card>
                            <CardBody>
                                <Spin spinning={this.state.tableloading}>
                                    <FormGroup>
                                        <Table
                                            rowKey={key => key.LTMP_ID}
                                            pagination={{
                                                current: this.state.currentpage,
                                                defaultPageSize: "10",
                                                pageSizeOptions: ['10', '20', '50'],
                                                showSizeChanger: true,
                                                total: this.state.totalpage,
                                                showTotal: (total, range) => `${range[0]}-${range[1]} of ${this.state.totalpage} items`,
                                                onShowSizeChange: (currentPage, pageSize) => this.onChangePage(currentPage, pageSize),
                                                onChange: (currentPage, pageSize) => this.onChangePage(currentPage, pageSize)
                                            }}
                                            columns={columns}
                                            dataSource={data}
                                        />
                                    </FormGroup>
                                </Spin>
                            </CardBody>
                        </Card>
                    </Col>
                </div>

                <Modal
                    visible={this.state.visible}
                    closeIcon={false}
                    width="60%"
                    onOk={this.handleCancelModel}
                    onCancel={this.handleCancelModel}
                    cancelButtonProps={{ style: { display: 'none' } }}
                    okButtonProps={{ style: { display: 'none' } }}
                >
                    <Row gutter={8} type="flex" justify="space-between">
                        <Col xs={12}>
                            <h5>Preview</h5>
                        </Col>
                        <Col xs={12} style={{ textAlign: 'right' }}>
                            <span style={{ textAlign: 'center', cursor: 'pointer' }}>
                                <i
                                    className="fa fa-times-circle-o card-close"
                                    onClick={this.handleCancelModel}
                                ></i>
                            </span>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Row gutter={16} type="flex" justify="center">
                            <Col xs={24} sm={24} md={24} lg={24} xl={12} style={{ textAlign: 'center', overflow: 'auto' }}>
                                <Row>
                                    {
                                        this.state.images !== "" ?
                                            <img src={pathimages + this.state.images}
                                                style={{ width: 'auto', minHeight: 50, maxHeight: 300 }} />
                                            :
                                            <img src={pathimages + "placeholder-image.png"}
                                                style={{ width: 'auto', minHeight: 50, maxHeight: 280 }} />
                                    }
                                </Row>
                                <Row style={{ marginTop: "50px" }}>
                                    <Button
                                        type="primary"
                                        ghost
                                        onClick={() => this.copyToClipboard(this.state.tempContent)}
                                    >
                                        COPY
                                    </Button>
                                </Row>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={24} xl={12}>
                                <pre>{this.state.tempContent}</pre>
                            </Col>
                        </Row>
                    </Row>
                </Modal>
            </div>

        );
    }
}

export default Template;



// WEBPACK FOOTER //
// ./src/views/Template/Template.js